import BuilderDetailsView from "@/ui/views/builders/BuilderDetailsView.vue";
import BuilderListView from "@/ui/views/builders/BuilderListView.vue";
import BuilderJoinView from "@/ui/views/builders/join/BuilderJoinView.vue";
import BuilderLandingView from "@/ui/views/builders/join/BuilderLandingView.vue";
import ContactUsView from "@/ui/views/ContactUsView.vue";
import CookiePolicy from "@/ui/views/CookiePolicy.vue";
import MaintenanceView from "@/ui/views/error/MaintenanceView.vue";
import NotFoundView from "@/ui/views/error/NotFoundView.vue";
import EventDetailsView from "@/ui/views/events/EventDetailsView.vue";
import EventListView from "@/ui/views/events/EventListView.vue";
import FreePredictions from "@/ui/views/FreePredictions.vue";
import LandingPageView from "@/ui/views/landing-pages/LandingPageView.vue";
import MarchMadnessLanding from "@/ui/views/march-madness/MarchMadnessLanding.vue";
import MarchMadnessUpsell from "@/ui/views/march-madness/MarchMadnessUpsell.vue";
import ModelDetailsView from "@/ui/views/models/ModelDetailsView.vue";
import ModelListView from "@/ui/views/models/ModelListView.vue";
import PaymentView from "@/ui/views/payment/PaymentView.vue";
import PrivacyPageView from "@/ui/views/PrivacyPageView.vue";
import CancelSubscription from "@/ui/views/profile/CancelSubscription.vue";
import CancelSubscriptionResult from "@/ui/views/profile/CancelSubscriptionResult.vue";
import ManageSubscription from "@/ui/views/profile/ManageSubscription.vue";
import ProfilePageView from "@/ui/views/profile/ProfilePageView.vue";
import RegisterUpsellView from "@/ui/views/register/RegisterUpsellView.vue";
import RegisterView from "@/ui/views/register/RegisterView.vue";
import SubmitAbugView from "@/ui/views/SubmitAbugView.vue";
import TermsPageView from "@/ui/views/TermsPageView.vue";
import HomeView from "../ui/views/HomeView.vue";
import VexalabsPageView from "@/ui/views/tempVexalabs.vue";
import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: HomeView
  },
  {
    path: "/register",
    children: [
      {
        path: "",
        name: "register",
        component: RegisterView
      },
      {
        path: "get-predictions/:target?",
        name: "register-upsell",
        component: RegisterUpsellView
      }
    ]
  },
  {
    path: "/march-madness/landing",
    name: "march-madness-landing",
    component: MarchMadnessLanding
  },
  {
    path: "/march-madness/get-predictions",
    name: "march-madness-upsell",
    component: MarchMadnessUpsell
  },
  {
    path: "/email/verify/:id/:hash",
    name: "verify-email",
    component: HomeView,
    meta: { action: "verify" }
  },
  {
    path: "/reset-password/:hash",
    name: "reset-password",
    component: HomeView,
    meta: { action: "reset" }
  },
  {
    path: "/landing/:slug?",
    name: "landing",
    component: LandingPageView
  },
  {
    path: "/landing-v2/:slug?",
    redirect: (to) => {
      return {
        name: "landing",
        params: { slug: to.params.slug }
      };
    }
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPageView
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: CookiePolicy
  },
  {
    path: "/free-predictions",
    name: "free-predictions",
    component: FreePredictions
  },
  {
    path: "/profile",
    children: [
      {
        path: "",
        name: "profile",
        component: ProfilePageView
      },
      {
        path: "cancel-subscription",
        name: "profile-cancel-subscription",
        component: CancelSubscription
      },
      {
        path: "manage-subscription",
        name: "profile-manage-subscription",
        component: ManageSubscription
      },
      {
        path: "cancel-subscription-result",
        name: "profile-cancel-subscription-result",
        component: CancelSubscriptionResult
      }
    ]
  },
  {
    path: "/terms-of-use",
    name: "terms-of-use",
    component: TermsPageView
  },
  {
    path: "/submit-a-bug",
    name: "submit-bug",
    component: SubmitAbugView
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: ContactUsView
  },
  {
    path: "/events/:type?/:subType?",
    name: "events",
    component: EventListView,
    meta: { type: "events" }
  },
  {
    path: "/events/:eventId/details",
    name: "single-event",
    component: EventDetailsView,
    meta: { type: "events" }
  },
  {
    path: "/models/:type?/:subType?",
    name: "models",
    component: ModelListView,
    meta: { type: "models" }
  },
  {
    path: "/models/:modelId/details",
    name: "single-model",
    component: ModelDetailsView,
    meta: { type: "models" }
  },
  {
    path: "/creators",
    children: [
      {
        path: "",
        name: "creators",
        component: BuilderListView
      },
      {
        path: ":builderId/details",
        name: "creator.details",
        component: BuilderDetailsView,
        meta: { type: "creators" }
      },
      {
        path: "welcome",
        name: "creator.welcome",
        component: BuilderLandingView
      },
      {
        path: "join",
        name: "creator.join",
        component: BuilderJoinView
      }
    ]
  },
  {
    path: "/payment/:orderId",
    name: "payment",
    component: PaymentView
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: MaintenanceView
  },
  {
    path: "/not-found",
    name: "not-found",
    component: NotFoundView
  },
  {
    path: "/vexalabs",
    name: "vexalabs",
    component: VexalabsPageView
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/"
  }
];
